


























































































import { Component, Vue, Watch } from "vue-property-decorator";
import AgencyDto from "@/models/Agencies/AgencyDto";
import UpdateAgencyProfileDetailsRequest from "@/models/Agencies/UpdateAgencyProfileDetailsRequest";
import Validator from "@/lib/validator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import ListUtils from "@/lib/listUtils";
import { AgencySettingsModule } from "@/store/modules/agencySettings";

@Component({
  name: "AgencyProfileDetailsEdit",
})
export default class extends GiganautVueDialog {

  public entity = new AgencyDto();

  @Watch("dialog")
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.agency));
    }
  }

  get brandThemeModes() {
    return ListUtils.brandThemeModes();
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateAgencyProfileDetailsRequest();
    request.updatedAt = AgencySettingsModule.agency.updatedAt;
    request.biography = this.entity.biography;
    request.website = this.entity.website;
    request.brandName = this.entity.brandName;
    request.brandPrimaryColour = this.entity.brandPrimaryColour;
    request.brandThemeMode = this.entity.brandThemeMode;
    await AgencySettingsModule.editAgencyProfileDetails(request);
    this.dialog = false;
  }
}
